import type { Announcement } from "./contract";

type ArtifactMachine = {
  id?: string;
  name?: string;
  status?: string;
};

type ArtifactShell = {
  machine?: ArtifactMachine;
};

const machineOf = (artifact: unknown): ArtifactMachine | undefined =>
  (artifact as ArtifactShell | undefined)?.machine;

export const payloadArtifactOf = (announcement: Announcement): unknown =>
  announcement.artifact?.[0];

export const renderArtifactOf = (announcement: Announcement): unknown => {
  const payloadArtifact = payloadArtifactOf(announcement);
  if (payloadArtifact) return payloadArtifact;
  const renderMachine = announcement.render.find((rf) => rf.machine?.id || rf.machine?.name)?.machine;
  return renderMachine ? { machine: renderMachine, params: [] } : undefined;
};

export const artifactMachineIdOf = (artifact: unknown): string =>
  String(machineOf(artifact)?.id || "");

export const artifactMachineRefOf = (artifact: unknown): string =>
  String(machineOf(artifact)?.id || machineOf(artifact)?.name || "");

export const artifactMachineStatusOf = (artifact: unknown): string =>
  String(machineOf(artifact)?.status || "");

export const announcementArtifactMachineIdOf = (announcement: Announcement): string =>
  artifactMachineIdOf(renderArtifactOf(announcement));

export const hasArtifactMachine = (artifact: unknown): boolean =>
  !!artifactMachineRefOf(artifact);
